<template>
  <b-modal class="accountability" v-if="serviceOrder && accountability" v-model="isOpen" size="xl"
    hide-footer :title="`Prestação de Contas de Serviço ${serviceOrder.fileNumber}`">

    <div class="accountability-mobile">
      <b-card>
        <b-tabs justified v-model="tabIndex">
          <b-tab title="Geral">
            <div class="general-mobile" v-for="booking, i in guideBookings" :key="booking.id">
              <h5><b>{{ booking.booking.bookingNumber }} - {{ booking.booking.date | date }}</b></h5>
              <span><b>Descritivo:</b> {{ booking.booking.service && booking.booking.productName }}</span> <br />
              <span><b>Valor:</b> {{ booking.booking.costPriceCurrency ? booking.booking.costPriceCurrency.symbol : "$"}}
              {{ diffCostPrice() ? "--" : booking.bookingCostPrice }}</span> <br />
              <div class="receivement-optional-field" v-if="booking.booking.optional">
                <span><b>Valor Opc:</b> {{ booking.booking.priceCurrency ? booking.booking.priceCurrency.symbol : "$" }}
                  {{ booking.booking.activePrice }}</span>
                <br />
              </div>
              <div class="receivements-card" v-if="booking.booking.optional">
                <div class="receivements-card-title">
                  <h6><b>Recebimentos</b></h6>
                  <span class="d-flex">
                    {{ booking.receivementsOpen }}
                    <i v-if="!guideCanOnlyView" v-show="openReceivementIndex === i || booking.receivements.length == 0" class="material-icons align-middle pointer" @click="addReceivement(booking)">add_circle</i>
                    <i v-if="booking.receivements.length > 0" class="material-icons align-middle pointer" @click="openReceivementIndex = openReceivementIndex === i ? -1 : i">{{ openReceivementIndex === i ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
                  </span>
                </div>
                <div v-if="booking.receivements.length > 0" v-show="openReceivementIndex === i">
                  <ul v-for="receivement, j in booking.receivements" style="padding: 0;">
                    <li :key="j">
                      <receivement :receivement="receivement"
                        @update:receivement="receivement.id ? syncUpdatedReceivement(booking, j, $event) : syncCreatedReceivement(booking, j, $event)"
                        @remove:receivement="removeReceivement(booking, $event)"
                        :accountability="accountability" :booking="booking" @removed="syncRemoveReceivement(booking, j)"
                        :labels="true" :noDelete="guideCanOnlyView || !receivement.id" :useSaveIcon="true"
                        :noSave="guideCanOnlyView" />
                      <hr v-if="j < booking.receivements.length - 1">
                    </li>
                  </ul>
                </div>
              </div>
              <hr v-if="i < guideBookings.length - 1">
            </div>
          </b-tab>
          <b-tab title="Despesas">
            <div v-if="noExpenses" class="expenses-title">
              <h5><b>Nenhuma despesa registrada</b></h5>
            </div>

            <div v-if="!showExpenseForm && expensesWithoutReceipt && expensesWithoutReceipt.length" class="expenses-title">
              <h5><b>Despesas sem Recibo</b></h5>
            </div>

            <div v-for="({ expense, index }, i) in expensesWithoutReceipt">
              <div class="expenses-data" :key="index">
                <span><b>Data:</b> {{ expense.date | date }}</span> <br />
                <span><b>Descritivo:</b> {{ expense.description }}</span> <br />
                <span><b>Valor:</b> R$ {{ expense.costPrice }}</span>
                <br />
                <br />
                <div v-if="!guideCanOnlyView" class="data-actions">
                  <i v-if="!expense.isEditing && !showExpenseForm" @click="removeExpense(expense)" class="material-icons pointer" v-b-tooltip="'Remover'">delete</i>
                  <i v-if="!expense.isEditing && !showExpenseForm" class="material-icons pointer" @click="openOrCloseExpense(expense)"
                    v-b-tooltip="'Editar'">edit</i>
                </div>
                <div v-if="expense.isEditing" class="form-edit-expense-without-receipt">
                  <b-form-group label-for="date" label="Data">
                    <blumar-date-input id="date" v-model="expense.date" size="md" />
                  </b-form-group>
                  <labeled-input id="description" v-model="expense.description" label="Descrição" />
                  <labeled-input id="cost" v-model="expense.costPrice" type="decimal" label="Valor" />
                  <br />
                  <div class="expense-action">
                    <b-button @click="acceptChangeExpense(expense, index)">Confirmar</b-button>
                    <b-button @click="openOrCloseExpense(expense)" variant="danger">Cancelar</b-button>
                  </div>
                </div>
                <hr v-if="i < expensesWithoutReceipt.length - 1" />
              </div>
            </div>

            <hr v-if="!showExpenseForm && expensesWithReceipt && expensesWithReceipt.length" style="height:1px;border-width:0;color:gray;background-color:gray">
            <div v-if="!showExpenseForm && expensesWithReceipt && expensesWithReceipt.length" class="expenses-title">
              <h5><b>Despesas com Recibo</b></h5>
            </div>

            <div v-for="({ expense, index }, i) in expensesWithReceipt">
              <div class="expenses-data" :key="index">
                <span><b>Data:</b> {{ expense.date | date }}</span> <br />
                <span><b>Descritivo:</b> {{ expense.description }}</span> <br />
                <span><b>Valor:</b> R$ {{ expense.costPrice }}</span> <br />
                <div class="expense-receipt-number">
                  <span><b>Recibo:</b> {{ expense.receiptNumber }}</span>
                  <a class="material-icons pointer" href="#" @click.prevent="downloadfile(expense.receipt)"
                    v-b-tooltip="'Baixar recibo'">description</a>
                </div>
                <br />
                <div v-if="!guideCanOnlyView" class="data-actions">
                  <i v-if="!expense.isEditing && !showExpenseForm" @click="removeExpense(expense)" class="material-icons pointer" v-b-tooltip="'Remover'">delete</i>
                  <i v-if="!expense.isEditing && !showExpenseForm" class="material-icons pointer" @click="openOrCloseExpense(expense)"
                    v-b-tooltip="'Editar'">edit</i>
                </div>
                <div v-if="expense.isEditing" class="form-edit-expense-with-receipt">
                  <b-form-group label-for="date" label="Data">
                    <blumar-date-input id="date" v-model="expense.date" size="md" />
                  </b-form-group>
                  <labeled-input id="description" v-model="expense.description" label="Descrição" />
                  <labeled-input id="cost" v-model="expense.costPrice" type="decimal" label="Valor" />
                  <labeled-input v-model="expense.receiptNumber" type="decimal" label="Recibo" />
                  <b-form-group
                    v-b-tooltip="expense.receiptFile ? 'Arquivo anexado: ' + expense.receiptFile.name : 'Anexar Recibo'">
                    <label class="edit-file-icon">
                      <i class="material-icons pointer" :class="{ 'light-blue': expense.receiptFile }">description</i>
                      <file-input @input="expense.receiptFile = $event" hidden />
                    </label>
                  </b-form-group>
                  <br />
                  <div class="expense-action">
                    <b-button @click="acceptChangeExpense(expense, index)">Confirmar</b-button>
                    <b-button @click="openOrCloseExpense(expense)" variant="danger">Cancelar</b-button>
                  </div>
                </div>
                <hr v-if="i < expensesWithReceipt.length - 1" />
              </div>
            </div>

            <hr v-if="!guideCanOnlyView" style="height:1px;border-width:0;color:gray;background-color:gray">
            <div v-if="!guideCanOnlyView" class="form-new-expense">
              <div class="new-expensive-action">
                <i v-if="!showExpenseForm" class="material-icons pointer" @click="openFormNewExpense()" v-b-tooltip="'Adicionar nova despesa'">add_circle</i>
              </div>
              <div v-if="showExpenseForm">
                <h5 class="new-expense-title"><b>Nova Despesa</b></h5>
              </div>
              <b-form v-if="showExpenseForm" class="form-expense" @submit.prevent="addExpense">
                <b-form-group label-for="date" label="Data">
                  <blumar-date-input id="date" v-model="newExpense.date" size="md" />
                </b-form-group>
                <labeled-input id="description" v-model="newExpense.description" label="Descrição" />
                <labeled-input id="cost" v-model="newExpense.costPrice" type="decimal" label="Valor" />
                <b-form-group label-for="receipt" label="Recibo" label-cols>
                  <b-checkbox id="receipt" v-model="newExpense.hasReceipt" />
                </b-form-group>
                <div class="expense-file" v-if="newExpense.hasReceipt">
                  <div id="receipt-number-box">
                    <labeled-input id="receiptNumber" v-model="newExpense.receiptNumber" label="Número do Recibo" />
                  </div>
                  <label class="label-file-mobile"
                    v-b-tooltip="newExpense.receiptFile ? 'Arquivo anexado: ' + newExpense.receiptFile.name : 'Anexar Recibo'">
                    <i class="material-icons pointer" :class="{ 'light-blue': newExpense.receiptFile }">description</i>
                    <file-input @input="newExpense.receiptFile = $event" hidden />
                  </label>
                </div>
                <div class="expense-action">
                  <b-button type="submit">Confirmar</b-button>
                  <b-button @click="closeFormNewExpense()" variant="danger">Cancelar</b-button>
                </div>
              </b-form>
            </div>
          </b-tab>
          <b-tab title="Anexos">
            <div class="general-mobile">
              <div style="display: flex; gap: 5px;">
                <h5>Anexos</h5>
                <label v-if="!guideCanOnlyView" class="add-attachment material-icons" for="file-input">add_circle</label>
                <file-input id="file-input" @input="addAttachment" hidden />
              </div>
              <div v-for="(attach, i) in accountability.attachmentPaths" :key="attach" class="attachment">
                <a href="#" @click.prevent="downloadfile(attach)">
                  {{baseFileName(attach)}}
                </a>
                <span v-if="!guideCanOnlyView" class="delete-button material-icons" @click="removeAttachmentPath(i)">delete</span>
              </div>
              <div v-for="(attach, i) in accountability.attachments" :key="attach.name" class="attach-wrapper">
                <span>{{attach.name}}</span>
                <span class="delete-button material-icons" @click="removeAttachment(i)">delete</span>
              </div>
            </div>
          </b-tab>
          <hr style="height:1px;border-width:0;color:gray;background-color:gray">
          <div v-if="tabIndex != attachmentTabIndex" class="total-cost-area">
            <div class="cost-field">
              <h6><b>Custo:</b></h6>
              <span><strong class="cost-price">R$ {{ getValidCostPrice() | number }}</strong></span>
            </div>
            <div v-if="expensesWithoutReceipt.length > 0">
              <hr />
              <div class="cost-field">
                <h6><b>Desp. sem Recibo:</b></h6>
                <span><strong class="cost-price">R$ {{ expensesWithoutReceiptCostSum | number }} </strong></span>
              </div>
            </div>
            <div v-if="expensesWithReceipt.length > 0">
              <hr />
              <div class="cost-field">
                <h6><b>Desp. com Recibo:</b></h6>
                <span><strong> R$ {{ expensesWithReceiptCostSum | number }} </strong></span>
              </div>
            </div>
            <hr />
            <div class="cost-field">
              <h6><b>Custo Total:</b></h6>
              <span><strong> R$ {{ getValidCostPrice() + expensesWithoutReceiptCostSum + expensesWithReceiptCostSum | number }}
                </strong></span>
            </div>
            <hr />
          </div>
        </b-tabs>
        <div v-if="!guideCanOnlyView" class="conclude-accountability">
          <form-button v-if="tabIndex == attachmentTabIndex && updatableInfoChanged" size="auto" @click="saveAttachments" title="Salvar Anexos"/>
          <form-button v-if="tabIndex != attachmentTabIndex && canConclude()" size="auto" @click="completeAccountability" title="Concluir prestação de contas"/>
        </div>
        <span v-else class="conclude-accountability">
            Prestação de contas concluída em {{ this.accountability.concludedDate }}
        </span>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment';
import LabeledInput from '../../shared/LabeledInput.vue';
import { formatNumber, getNumber, requestAction, fetchModel, alerter, deepCopy, downloadFile, baseFileName } from '../../../utils';
import ServiceOrderService from '../../../service/ServiceOrderService';
import AccountabilityService from '../../../service/AccountabilityService';
import ExpenseService from '../../../service/ExpenseService';
import StorageService from '../../../service/StorageService';
import FileInput from '../../shared/FileInput.vue';
import BlumarDecimalInput from '../../shared/BlumarDecimalInput.vue';
import Editable from './Editable.vue';
import { AccountabilityStatus } from '../../../enums/AccountabilityStatus';
import FormButton from '../../shared/FormButton.vue';
import BlumarMultiSelect from '../../shared/BlumarMultiSelect.vue';
import Receivement from './Receivement.vue';
import { sum, isEqual, last } from 'lodash';
import Editing from './Editing.vue';
import BlumarDateInput from '../../shared/BlumarDateInput.vue';
import { GuideAcceptanceStatus } from '../../../enums/GuideAcceptanceStatus';
import { ReceivementType } from '../../../enums/ReceivementType'
import { Currency } from '../../../enums/Currency';
import { ReservationStatus } from '../../../enums/ReservationStatus';

function cloneDeep(x) {
  return JSON.parse(JSON.stringify(x));
}

let Expense = (accountability, exp = {}) => ({
  id: exp.id,
  receiptNumber: exp.receiptNumber,
  date: exp.date,
  costPrice: exp.costPrice,
  description: exp.description,
  receipt: exp.receipt,
  receiptFile: exp.receiptFile,
  isEditing: exp.isEditing || false,
  accountability: { id: accountability.id },
  key: Math.floor(Math.random() * 1000).toString(),
  isDeleting: false,
  hasReceipt: !!exp.receipt || !!exp.receiptFile,
});

export default {
  components: { LabeledInput, FileInput, BlumarDecimalInput, Editing, Editable, FormButton, BlumarMultiSelect, Receivement, BlumarDateInput },
  data() {
    return {
      isOpen: false,
      serviceOrder: null,
      accountability: null,
      newExpense: null,
      someExpenseIsEditing: false,
      showExpenseForm: false,
      serviceOrderService: new ServiceOrderService(),
      accountabilityService: new AccountabilityService(),
      expenseService: new ExpenseService(),
      storageService: new StorageService(),
      guideBookings: [],
      tabIndex: 0,
      attachmentTabIndex: 2,
      openReceivementIndex: -1,
      updatableInfoChanged: false,
    };''
  },
  watch: {
   "accountability.attachments" (newVal, oldVal) {this.updatableInfoChanged = true},
   "accountability.attachmentPaths" (newVal, oldVal) {this.updatableInfoChanged = true}
  },
  computed: {
    noExpenses() {
      return (!this.expensesWithReceipt || !this.expensesWithReceipt.length) && (!this.expensesWithoutReceipt || !this.expensesWithoutReceipt.length)
    },
    expensesWithReceipt() {
      return this.accountability.expenses.map((e, i) => ({ expense: e, index: i }))
        .filter(({ expense: e }) => e.receipt || e.receiptFile);
    },
    expensesWithoutReceipt() {
      return this.accountability.expenses.map((e, i) => ({ expense: e, index: i }))
        .filter(({ expense: e }) => !e.receipt && !e.receiptFile);
    },
    costPriceSum() {
      return this.guideBookings
        .filter(b => b.booking.allocationType !== "SIB")
        .reduce((acc, b) => acc + getNumber(b.bookingCostPrice), 0);
    },
    expensesWithReceiptCostSum() {
      return this.expensesWithReceipt.reduce((acc, { expense: e }) => acc + getNumber(e.costPrice || '0'), 0);
    },
    expensesWithoutReceiptCostSum() {
      return this.expensesWithoutReceipt.reduce((acc, { expense: e }) => acc + getNumber(e.costPrice || '0'), 0);
    },
    guideCanOnlyView() {
      return this.accountability.status.id !== AccountabilityStatus.PENDING.id && this.accountability.status.id !== AccountabilityStatus.REFUSED.id;
    },
  },
  methods: {
    baseFileName,
    async open(serviceOrder) {
      this.serviceOrder = serviceOrder;
      this.accountability = await this.getGuideAccountability(serviceOrder);
      this.accountability.expenses = this.accountability.expenses.map((e) => Expense(this.accountability, e));
      this.guideBookings = this.getGuideBookings();
      this.isOpen = true;
      this.showExpenseForm = false
      setTimeout(() => {this.updatableInfoChanged = false;}, 200);
    },
    getGuideAccountability(serviceOrder) {
      return fetchModel('prestação de conta', () => this.serviceOrderService.getGuideAccountability(serviceOrder.id));
    },
    getGuideBookings() {
      let guideBookings = this.serviceOrder.bookings.filter(b => this.isBookingKK(b) && b.guide && b.guide.id === this.$store.state.user.id && this.isStatus(b, GuideAcceptanceStatus.ACCEPTED))
        .map(b => ({ ...cloneDeep(b), guideServiceOrderBooking: b }));
      return guideBookings;
    },
    async addExpense() {
      if (!this.validate(this.newExpense)) return;
      let expense = Expense(this.accountability, this.newExpense);
      let success = "Despesa adicionada com sucesso";
      let failure = "Falha ao adicionar despesa";
      expense = await requestAction(success, failure, this.accountabilityService.saveExpense(this.accountability.id, expense));
      this.accountability.expenses.push(Expense(this.accountability, expense));
      this.newExpense = null;
      this.showExpenseForm = false;
    },
    validate(expense) {
      if (!moment(expense.date, 'DD/MM/YYYY').isValid())
        return alerter.warn('Data inválida');
      if (!expense.description)
        return alerter.warn("Informe a descrição da despesa");
      if (!expense.costPrice)
        return alerter.warn("Informe o valor da despesa");
      if (expense.hasReceipt && (!(expense.receiptFile || expense.receipt) || !expense.receiptNumber))
        return alerter.warn("Número do recibo e anexo do recibo devem ser enviados juntos, caso a despesa possua recibo.");
      return true;
    },
    async saveExpenseEditing(expense, i) {
      if (!this.validate(expense)) return;
      let success = "Despesa salva sucesso";
      let failure = "Falha ao salvar despesa";
      let saved = await requestAction(success, failure, this.expenseService.save(expense));
      expense.isEditing = !expense.isEditing;
      expense = Expense(this.accountability, saved);
      this.$set(this.accountability.expenses, i, expense);
    },
    async removeExpense(expense) {
      if(!confirm("Deseja realmente remover esta despesa?"))
        return;
      let success = "Despesa removida com sucesso";
      let failure = "Falha ao remover despesa";
      expense.isDeleting = false;
      await requestAction(success, failure, () => this.expenseService.remove(expense.id));
      this.accountability.expenses = this.accountability.expenses.filter(e => e.id !== expense.id);
    },
    async completeAccountability() {
      let bookingsReceivements = (bookings) => bookings.map(b => ({ id: b.id, receivements: b.receivements }));
      if (!isEqual(bookingsReceivements(this.getGuideBookings()), bookingsReceivements(this.guideBookings)))
        return alerter.warn("É necessário salvar o recebimento antes de concluir a prestação de contas!");
      if (!confirm("Deseja concluir a prestação de contas?")) return;
      let success = "Prestação de contas concluida com sucesso";
      let failure = "Falha ao concluir prestação de contas";
      this.accountability = await requestAction(success, failure, () => this.accountabilityService.changeStatus(this.accountability.id, AccountabilityStatus.CONCLUDED.id));
    },
    async saveAttachments() {
      let success = "Anexos salvos com sucesso";
      let failure = "Falha ao salvar anexos";
      let savedAccountability = await requestAction(success, failure, this.accountabilityService.saveAttachments(this.accountability.id, {attachmentPaths: this.accountability.attachmentPaths, attachments: this.accountability.attachments}));
      this.accountability = deepCopy(savedAccountability);
    },
    addReceivement(booking) {
      let lastReceivement = last(booking.receivements);
      if (lastReceivement && !lastReceivement.id) return;

      let receivement = {
        date: null,
        currency: Currency.REAL,
        value: '0,00',
        type: ReceivementType.CASH,
        exchange: booking.booking.priceCurrency.id === Currency.REAL.id ? "1,0000" : null,
      };
      booking.receivements.push(receivement);
    },
    removeReceivement(booking, receivement) {
      booking.receivements.splice(booking.receivements.indexOf(receivement) , 1);
    },
    syncUpdatedReceivement(booking, i, receivement) {
      this.$set(booking.receivements, i, receivement);
      booking.guideServiceOrderBooking.receivements[i] = cloneDeep(receivement);
    },
    syncCreatedReceivement(booking, i, receivement) {
      this.$set(booking.receivements, i, receivement);
      booking.guideServiceOrderBooking.receivements.push(cloneDeep(receivement));
    },
    syncRemoveReceivement(booking, i) {
      booking.receivements.splice(i, 1);
      booking.guideServiceOrderBooking.receivements.splice(i, 1);
    },
    receivementFinalValue(receivement, booking) {
      let exchange = getNumber(receivement.exchange);
      let value = getNumber(receivement.value);

      if (typeof exchange !== 'number') return value;

      let bookingCurrency = booking.booking.priceCurrency || Currency.REAL;

      if (!bookingCurrency || receivement.currency.id < bookingCurrency.id)
        return value / exchange;
      else if (receivement.currency.id > bookingCurrency.id)
        return value * exchange;
      else
        return value;
    },

    receivementsTotalValue(booking) {
      return sum(booking.receivements.map(r => this.receivementFinalValue(r, booking)));
    },
    isStatus(booking, status) {
      return booking.guideStatus.id === status.id;
    },
    openOrCloseExpense(expense) {
      expense.isEditing = !expense.isEditing;
      this.someExpenseIsEditing = !this.someExpenseIsEditing;
    },
    acceptChangeExpense(expense, index) {
      this.saveExpenseEditing(expense, index).then(() => {
        this.openOrCloseExpense(expense);
      });
    },
    openFormNewExpense() {
      this.newExpense = Expense(this.accountability);
      this.showExpenseForm = true;
    },
    closeFormNewExpense() {
      this.newExpense = null;
      this.showExpenseForm = false;
    },
    addAttachment(file) {
			let accountability = this.accountability;

			if (!accountability.attachments)
				this.$set(accountability, 'attachments', []);

			if (accountability.attachments.every(a => a.name !== file.name))
        accountability.attachments.push(file);
		},
    removeAttachmentPath(i) {
			this.accountability.attachmentPaths.splice(i, 1);
		},
    removeAttachment(i) {
			this.accountability.attachments.splice(i, 1);
		},
    isBookingKK(serviceOrderBooking) {
			return serviceOrderBooking.booking.status.id === ReservationStatus.KK.id;
		},
    diffCostPrice() {
      if(this.isAlreadyConcluded() && this.costPriceSum != getNumber(this.accountability.persistedCostPrice))
        return true;
      return false;
    },
    isAlreadyConcluded() {
      return this.accountability.status.id === AccountabilityStatus.CONCLUDED.id || this.accountability.status.id === AccountabilityStatus.APPROVED.id || this.accountability.status.id === AccountabilityStatus.AUTHORIZED.id || this.accountability.status.id === AccountabilityStatus.PAID.id;
    },
    getValidCostPrice() {
      if(this.diffCostPrice())
        return getNumber(this.accountability.persistedCostPrice);
      return this.costPriceSum;
    },
    canConclude() {
      return !this.guideBookings.find(b => b.receivements.find(r => !r.id)) && !this.newExpense && !this.someExpenseIsEditing;
    },
    downloadfile(filePath) {
			return downloadFile(filePath, path => this.storageService.downloadFile(path));
		},
  },
  filters: {
    number(value) {
      return value && formatNumber(value, 2);
    },
    date(v) {
      return moment(v, 'DD/MM/YYYY').format('ddd - DD/MM/YYYY');
    }
  }
}
</script>

<style lang="scss" scoped>
.accountability-mobile {
  display: none;
}

.date {
  width: 155px;
  white-space: nowrap;
}

.cost-price {
  width: 120px;
  white-space: nowrap;
}

.price {
  white-space: nowrap;
}

.receipt-number {
  width: 150px;
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
  user-select: none;
}

footer {
  display: flex;
  justify-content: space-between;
}

.light-blue {
  color: #0ac6b7;
}

.accountability-mobile {
  display: block;
}

.general-mobile {
  margin-top: 5%;
}

ul {
  list-style-type: none;
}

.receivement-optional-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.receivements-card {
  padding: 1px 5px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: .25rem;
}

.receivements-card-title {
  display: flex;
  justify-content: space-between;
}

.total-cost-area {
  font-size: 95%;

  .cost-field {
    display: flex;
    justify-content: space-between;
    h6, span {
      margin: 0;
    }

  }
}

.data-actions,
.expense-receipt-number {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.expense-receipt-number {
  margin-right: 10%;
  justify-content: space-between;
}

.data-actions {
  justify-content: space-around;
}

.expenses-title {
  margin-top: 3%;
  margin-bottom: 5%;
}

.new-expensive-action,
.edit-file-icon,
.conclude-accountability {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.form-expense, .form-edit-expense-without-receipt, .form-edit-expense-with-receipt {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.form-expense {
  flex-wrap: wrap;
}

.form-edit-expense-with-receipt {
 * {
  margin: 0.5% 1%;
 }

 .expense-action {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-right: 2%;
 }
}

.expense-file {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-around;
  margin-bottom: 5%;

  label {
    margin-bottom: 10%;
  }
}

.add-receivement {
  margin-left: 45%;
}

#receipt-number-box {
  display: flex;
  width: 50%;
}

.edit-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.conclude-accountability {
  margin-top: 5%;
}

.p-detail {
  font-size: 8pt;
}

.add-attachment, .delete-button {
	margin-left: 10px;
	color: #163247;
	cursor: pointer;

	&:hover {
			color: #0d1d2a;
	}
}

.attachment, .attach-wrapper {
	display: flex;
	justify-content: flex-start;
	width: 100%;
	padding: 3px 5px;
}

.new-expense-title {
  text-align: center;
  margin-bottom: 2%;
}

@media screen and (max-width: 750px) {
  .accountability-desktop {
    display: none;
  }

  .accountability-mobile {
    display: block;
  }

  .form-expense, .form-edit-expense-without-receipt, .form-edit-expense-with-receipt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/os/accountability/Accountability.vue